module.exports = __webpack_public_path__ + "img/facebook.ab8853a2.svg";